import { GameFont } from "by/gamefactory/cityversetycoon/scenes/common/GameFont";
import { TextStyle } from "pixi.js";
import { UnboardingResourcePackage } from "../../../resources/UnboardingResourcePackage";
import { Sector } from "./Sector";

export class SecondSector extends Sector {
    private static readonly SECTOR_TEXT = "OWNER";

    public constructor(unboardingResources: UnboardingResourcePackage) {
        super(unboardingResources.assets_views_unboarding_second_fragment_png, SecondSector.SECTOR_TEXT, new SectorTextStyle());
        this.setSectorTextPosition(62, 61);
    }
}

class SectorTextStyle extends TextStyle {
    public constructor() {
        super({
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 72,
            fill: 'ffffff'
        });
    }
}